'use client'
import { getMembershipPath } from '@/src/routes/routes'
import PriceComponent from '../../common/PriceComponent'
import { formatAmount } from '@/src/utils/formatters'
import { Button } from '@heroui/react'
import { useAuth } from '@/src/hooks/useAuth'
import { useRouter } from 'nextjs-toploader/app'

interface MemberExclusivePriceProps {
    memberPrice: number
    retailPrice: number
    currency?: string
    isExclusive?: boolean
    isMember: boolean
}

export default function MemberExclusivePrice({ memberPrice, retailPrice, currency = '£', isExclusive = false, isMember }: MemberExclusivePriceProps) {
    const router = useRouter();
    const savings = retailPrice - memberPrice;

    return (
        <div className="rounded-lg bg-[#F4F7EE] px-4.5 py-4 flex flex-col gap-2 border border-[#E6EBDD4D] shadow-[0_4px_16px_0_rgba(130,168,54,0.10)]">
            {/* Header badges */}
            {/* {isMember ? (
                <p className="text-green-color text-xs font-semibold uppercase">
                    {isExclusive ? 'Exclusive member product' : 'Member price applied'}
                </p>
            ) : ( */}
            <div className="flex items-center gap-3">
                {/* {isExclusive ? (
                    <span className="bg-green-color text-white text-[8px] font-semibold tracking-widest uppercase px-2.25 py-0.75 rounded-full">
                        Members Only
                    </span>
                ) : ( */}
                <span className="bg-green-color text-white text-[8px] font-semibold tracking-widest uppercase px-2.25 py-0.75 rounded-full">
                    {isMember ? 'MEMBER ACTIVE' : 'Best Value'}
                </span>
                {/* )} */}
                <span className="text-green-color text-[10px] font-semibold tracking-widest uppercase">
                    {isExclusive ? 'Member Exclusive' : ''}
                </span>
            </div>
            {/* )} */}

            {/* Member price */}
            <p className="text-[30px] font-semibold">
                <PriceComponent currency={currency} price={memberPrice} />
            </p>

            {/* Savings badge — only for non-members on non-exclusive products */}
            {/* {!isMember && !isExclusive && ( */}
            <div className="inline-flex items-center gap-2 bg-[#E7F6E9] text-[#227D33] text-[11px] font-medium px-2.5 py-1.25 rounded-sm w-fit">
                <span>✓</span>
                {isMember ? <span>Your saved {formatAmount(savings, currency)} with your membership</span> : <span>Members save {formatAmount(savings, currency)} on this item</span>}
            </div>
            {/* )} */}

            {/* Exclusive notice for non-members */}
            {!isMember && isExclusive && (
                <div className="inline-flex items-center gap-2 bg-[#E7F6E9] text-[#227D33] text-[11px] font-medium px-2.5 py-1.25 rounded-sm w-fit">
                    <span>🔒</span>
                    <span>Membership required to purchase this item</span>
                </div>
            )}

            {/* CTA row — only shown to non-members */}
            {!isMember && (
                <div className="flex items-center justify-between gap-4 pt-2 border-t border-t-[#E6EBDD]">
                    <div>
                        <p className="text-[11px] text-[#4A4A4A]">Not a member yet?</p>
                        <p className="text-[11px] text-[#737373]">
                            {isExclusive
                                ? 'Join to purchase this exclusive item'
                                : 'Join to unlock exclusive member pricing'}
                        </p>
                    </div>
                    <Button
                        className="global_btn rounded_full min-h-4! px-4! text-xs!"
                        onClick={() => router.push(getMembershipPath())}
                    >
                        {isExclusive ? 'Join Now' : 'Unlock Member Price'}
                    </Button>
                </div>
            )}
        </div>
    )
}
